<template>
    <div>
        <div class="scroll-container">
            <div class="homeBanner">
                <el-carousel height="51rem">
                    <el-carousel-item v-for="item in homeBanner" :key="item.id">
                        <div class="banner">
                            <img :src="item.picture">
                        </div>
                    </el-carousel-item>
                </el-carousel>
            </div>
            <div class="charger_data">
                <div class="dataList">
                    <div>
                        <p>
                            <countTo :startVal='startVal' :endVal='electricity' :duration='3000' :decimals="decimals">{{
                        electricity }}</countTo>
                        </p>
                        <span>充电总量(度)</span>
                    </div>
                    <div>
                        <p>
                            <countTo :startVal='startVal' :endVal='carbonEmissions' :duration='3000'
                                :decimals="decimals">{{
                        carbonEmissions }}</countTo>
                        </p>
                        <span>减少碳排放（摩尔）</span>
                    </div>
                    <div>
                        <p>
                            <countTo :startVal='startVal' :endVal='treePlanting' :duration='3000'>{{
                        treePlanting }}</countTo>
                        </p>
                        <span>相当于植树（棵）</span>
                    </div>
                </div>
            </div>
            <div
                style="width: 100vw;height: 16rem;text-align: center;font-size: 3rem;line-height: 2rem;padding-top: 6rem;box-sizing: border-box;">
                <p>充电<span style="color: #0adfad;">更轻松</span> 生活<span style="color: #0adfad;">更低碳</span></p>
                <p style="font-size: 1rem; color: #808080;margin-top: 1rem;">CHARGING PLEASURE LOW CARBON LIVING</p>
            </div>
            <div class="about" :style="{ backgroundImage: `url(${aboutGxcImg})` }">
                <div @click="goDetail"
                    style="width: 16rem;height: 4rem;margin: 0 auto; color: #fff;font-size: 2rem;margin-top: 200px; border: 1px solid #fff;line-height: 4rem;border-radius: 10px;cursor: pointer;text-align: center;">
                    关于亘享充</div>
            </div>
            <div class="solution">
                <div class="title">
                    <h1 style="font-size: 3rem;">多场景解决方案</h1>
                    <p style="font-size: 1rem;color:#808080;margin-top: 1rem;">A MULTI-SCENARIO SOLUTION</p>
                    <img style='margin-top: 1rem;width: 10rem;' src="../../assets/images/xian.png" alt="">
                </div>
                <div class="solutionCase">
                    <div style="position: relative;" v-for="item in projectList" :key="item.id">
                        <router-link :to="item.link">
                            <img class="img" :src="item.pcPicture" alt="">
                            <p style="position: absolute;bottom: 0.5rem;left: 0.5rem;color: #fff;">{{ item.title }}</p>
                        </router-link>
                    </div>
                </div>
            </div>
            <div class="cooperation">
                <div class="title">
                    <h1 style="font-size: 3rem;">生态合作</h1>
                    <p style="font-size: 1rem; color:#808080;margin-top: 1rem;">A MULTI-SCENARIO SOLUTION</p>
                    <img style='margin-top: 1rem;width: 10rem;' src="../../assets/images/xian.png" alt="">
                </div>
                <div class="cooperationCase">
                    <div v-for="item in solutionList" :key="item.id">
                        <img :src="item.picture" alt="" @click="goPage(item)">
                        <p style="font-size: 32px;text-align: center;color: #fff;">{{ item.title }}</p>
                    </div>
                </div>
            </div>
            <div class="video">
                <video ref="myVideo" autoplay muted loop preload="true" :src="homeVideo"
                    style="width: 100vw !important;height: 68rem !important;object-fit: fill;">
                    <source type="video/mp4" :src="homeVideo" style="width: 100vw !important;height: 68rem!important;">
                </video>
            </div>

        </div>
        <!-- //侧边工具栏 -->
        <!-- <div class="shortcut">
            <div style="display: flex;flex-direction: column;align-content: center;" v-for="item in toolbarList">
                <img style="width: 1.5rem;height: 1.5rem;" :src="item.icon" alt="">
                <p style="color: #fff;margin-top: 5px;" @click="goContact">
                    {{ item.name }}</p>
            </div>
        </div> -->
    </div>
</template>
<script>
import CountTo from 'vue-count-to';
export default {
    components: { CountTo },
    data() {
        return {
            startVal: 0,
            electricity: 0,
            carbonEmissions: 0,
            treePlanting: 0,
            homeBanner: [],
            homeVideo: '',
            isPlayAnimation: false,
            toolbarList: [],
            projectList: [],
            ChargingData: [],
            decimals: 2,
            solutionList: [],
            aboutGxcImg: ''
        }
    },
    mounted() {
        this.getBannerList();
        this.getBannerVideo()
        this.videoElement = this.$refs.myVideo;
        // 添加 ended 事件监听器
        this.videoElement.addEventListener('ended', this.handleEnded);
        // this.getToolbarList()
        this.getSolutionSlide();
        this.getChargingdata();
        this.getSolutionList();
        this.aboutGxc()
    },
    methods: {
        goContact() {
            this.$router.push('/pc-contact')
        },
        //获取首页banner列表
        getBannerList() {
            this.$sys.bannerList({
                locationId: 1,
                pageId: 1
            }).then(res => {
                if (res.code == 200) {
                    this.homeBanner = res.data
                }
            })
        },
        //获取首页视频
        getBannerVideo() {
            this.$sys.bannerList({
                locationId: 2,
                pageId: 1
            }).then(res => {
                if (res.code == 200) {
                    this.homeVideo = res.data[0].picture
                }
            })
        },
        //获取工具栏内容
        getToolbarList() {
            this.$sys.toolbarList({}).then(res => {
                this.toolbarList = res.data
            })
        },
        //首页关于亘享充
        aboutGxc() {
            this.$sys.pageContentList({
                pageId: 1,
                userType: 1
            }).then(res => {
                console.log(res, '关于gxc');
                this.aboutGxcImg = res.data[0].content
                console.log(this.aboutGxcImg, 'gygxctp');
            })
        },
        //关于亘享充
        goDetail() {
            if (this.$route.path !== '/pc-about') {
                this.$router.push({
                    path: '/pc-about',
                })
            }
        },
        //获取首页解决方案
        getSolutionSlide() {
            this.$sys.projectList({}).then(res => {
                if (res.code == 200) {
                    this.projectList = res.data
                }
            })
        },
        //获取充电数据
        async getChargingdata() {
            let res = await this.$sys.chargingdataData()
            if (res.code == 200) {
                this.electricity = res.data.electricity;
                this.carbonEmissions = res.data.carbonEmissions;
                this.treePlanting = res.data.treePlanting
            }

        },
        //获取合作方式
        getSolutionList() {
            this.$sys.bannerList({
                pageId: 1,
                locationId: 3
            }).then(res => {
                if (res.code == 200) {
                    this.solutionList = res.data
                }
            })
        },
        goPage(item) {
            this.$router.push(item.link)
        },
        // goConnectivity() {
        //     this.$router.push('/cooperation-connected')
        // }

    }
}
</script>
<style lang="scss" scoped>
.homeBanner {
    width: 100vw;
    height: auto;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    margin: 0;
    padding: 0;

    .title .el-carousel__container {
        width: 100vw;
        height: 37.5rem;
    }

    .banner {
        width: 100vw;
        height: 51rem;
        background-image: url('../../assets/images/首页banner.jpg');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        display: flex;
        justify-content: space-around;
        align-items: center;
    }

}

.charger_data {
    background-image: url('../../assets/images/网站_02.jpg');
    width: 100vw;
    height: 12rem;

    .dataList {
        width: 72rem;
        height: 12rem;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        align-items: center;

        div {
            width: 24rem;
            font-size: 2rem;
            text-align: center;
            color: #fff;

            span {
                font-size: 1.6rem;
            }
        }
    }
}

.about {
    width: 100vw;
    height: 62rem;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    display: flex;
    align-items: center;
}

.solution {
    width: 100vw;
    height: 36rem;
    margin-top: 6rem;
    display: flex;
    flex-direction: column;
    align-items: center;

    .title {
        text-align: center;
    }

    .solutionCase {
        width: 111rem;
        height: 26rem;
        display: flex;
        justify-content: space-between;
        margin-top: 1rem;

        div {
            width: 27rem;
            height: 26rem;
            overflow: hidden;

            &:hover .img {
                transform: scale(1.3)
            }

            img {
                width: 100%;
                height: 100%;
                transition: all .6s;
            }
        }
    }
}

.cooperation {
    width: 100vw;
    height: 39rem;
    background-image: url('../../assets/images/网站_06.jpg');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    margin-top: 6rem;
    display: flex;
    flex-direction: column;
    align-items: center;

    .title {
        text-align: center;
    }

    .cooperationCase {
        width: 92rem;
        height: 26rem;
        margin: 0 auto;
        margin-top: 2rem;
        display: flex;
        justify-content: space-between;

        img {
            width: 45rem;
            height: 26rem;
        }
    }
}

.video {
    width: 100vw !important;
    height: 68rem !important;
    vertical-align: middle;
}

.shortcut {
    width: 4vw;
    height: auto;
    background-color: #4c94e6;
    position: fixed;
    top: 60vh;
    right: 2vw;
    z-index: 9999;
    display: flex;
    flex-direction: column;
    align-items: center;

    div {
        image {
            width: 1.5vw;
            height: 1.5rem;
        }

        p {
            font-size: 14px;
        }
    }
}
</style>